import moment from 'moment'
const message = 'A data de início deve ser antes da data de fim.'

export default {
  messages: {
    ptBR: () => message
  },
  validate(value, args) {
    const field = document.querySelector(`input[name="${args[0]}"]`)
    const start = value
    const end = field.value
    if (end === '') return false
    return moment(start).isBefore(moment(end))
  }
}
